import { ConfigProvider } from 'antd';
import { GeneralTranscription } from 'config/constants/transcription.constant';
import { SnackbarProvider } from 'notistack';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { App } from './app/App';
import { classicTheme } from './app/config/styles/theme';
import {
  AUTO_HIDE_DURATION,
  SnackbarUtilitiesConfig,
  snackbarComponentsOptions,
  snackbarOriginOptions,
} from './app/config/utils/snackbar.util';
import { persistor, store } from './store';

const container = document.getElementById('root');

if (!container) throw new Error(GeneralTranscription.ERROR_LOADING_APP);

const root = createRoot(container);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <SnackbarProvider
          Components={snackbarComponentsOptions}
          anchorOrigin={snackbarOriginOptions}
          autoHideDuration={AUTO_HIDE_DURATION}
          preventDuplicate
        >
          <SnackbarUtilitiesConfig />
          <ConfigProvider theme={classicTheme}>
            <App />
          </ConfigProvider>
        </SnackbarProvider>
      </PersistGate>
    </Provider>
  </React.StrictMode>,
);
